<template>
    <div class="bo-numeric-counter">
        <button type="button" @click="minusQuantity()">
            <i class="icon-remove"></i>
        </button>
        <div class="counter-display-wrapper" @click="startEditing">
            <span
                v-if="!isEditing"
                class="counter-text theme-primary-color"
                :title="formattedQuantity"
            >
                {{ formattedQuantity }}
            </span>
            <bo-cell-number
                v-show="isEditing"
                ref="cellNumber"
                class="theme-primary-color"
                :negative="negative"
                :editable="true"
                :eager="false"
                :min="min"
                :max="max"
                :decimal="quantityDecimalPlace"
                v-model="quantity"
                @blur.native.capture="stopEditing"
            ></bo-cell-number>
        </div>
        <button type="button" @click="addQuantity()">
            <i class="icon-add"></i>
        </button>
    </div>
</template>

<script>
import boCellNumber from "@/v2/components/bo-cell-number.vue";

export default {
    components: { boCellNumber },
    props: {
        value: {
            type: Number,
            default: 1,
        },
        negative: {
            type: Boolean,
            default: false,
        },
        min: {
            type: Number,
            default: Number.MIN_SAFE_INTEGER,
        },
        max: {
            type: Number,
            default: Number.MAX_SAFE_INTEGER,
        },
        quantityDecimalPlace: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            isEditing: false,
        };
    },
    model: {
        event: "change",
        prop: "value",
    },
    computed: {
        quantity: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("change", newValue);
            },
        },
        formattedQuantity() {
            const num = Number(this.quantity) || 0;
            const decimals = this.quantityDecimalPlace || 0;
            return num.toLocaleString(undefined, {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals,
            });
        },
    },

    methods: {
        startEditing() {
            this.isEditing = true;
            this.$nextTick(() => {
                const input = this.$el.querySelector("input");
                if (input) {
                    input.focus();
                    input.select();
                }
            });
        },

        stopEditing() {
            this.isEditing = false;
        },

        addQuantity() {
            if (this.quantity < this.max) {
                this.quantity++;
            }
        },

        minusQuantity() {
            if (this.quantity > this.min && (this.quantity > 0 || (this.negative && this.quantity < 1))) {
                this.quantity--;
            }
        },
    },
};
</script>
